import { anonymousClient, authenticatedClient } from './util'
import { HTTP_SUCCESS } from '../helpers/utils/http-status'

const fetchBundle = async (code: string) => {
    return anonymousClient()
        .get(
            `/api/bundle/${code}?populate=*`,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not fetch Bundle`)
            }
            return res
        }).then(res => res.data)
}

const updateMembershipFromNonPaymentBundle = async (code: string) => {
    return authenticatedClient()
        .post(
            `/api/bundle/membership-update-from-non-payment-bundle/${code}`,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not update membership`)
            }
            return res
        }).then(res => res.data)
}

const updateMembershipAfterPaymentForBundle = async (code: string, stripePaymentIntentId: string) => {
    return authenticatedClient()
        .post(
            `/api/bundle/membership-update-after-bundle-payment/${code}/${stripePaymentIntentId}`,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not update membership`)
            }
            return res
        }).then(res => res.data)
}

const createBundlePaymentOrder = async (code: string) => {
    return authenticatedClient()
        .post(
            `/api/bundle/create-bundle-payment-order/${code}`,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not update membership`)
            }
            return res
        }).then(res => res.data)
}

export {
    fetchBundle,
    updateMembershipFromNonPaymentBundle,
    createBundlePaymentOrder,
    updateMembershipAfterPaymentForBundle,
}